import { DOMAIN } from './Nav.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const canNavigate = state => getStore(state).canNavigate;
